var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeacherTreeViewArrow = function SvgTeacherTreeViewArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.293 3.96a1 1 0 0 0 1.414 0L7.53 1.136a.665.665 0 0 0-.94-.941L4 2.78 1.41.196a.665.665 0 0 0-.94.94L3.293 3.96Z",
    fill: "#6C6C73"
  })));
};
export default SvgTeacherTreeViewArrow;